import { defineStore } from "pinia";
import IFont from "types/IFont/IFont";
import defaultFonts from "../defaults/defaultFonts";
import { FontsSchema } from "@/schemas/font/fontSchema";
import { useNotificationsStore } from "./notifications";

interface FontOptions {
  override?: boolean;
  fonts: IFont[];
}

interface State {
  fonts: IFont[];
  fontSizes: number[];
  customFonts?: FontOptions;
}

export const useFontStore = defineStore("fonts", {
  state: (): State => ({
    fonts: defaultFonts,
    fontSizes: [11, 12, 13, 14, 15, 16, 17, 18, 20, 22, 24, 30, 36, 48, 64],
  }),

  getters: {
    fontsWithUrl(): IFont[] {
      return this.fonts.filter((font) => font.url !== undefined);
    },
  },

  actions: {
    setFontSizes(fontSizes: number[]) {
      this.fontSizes = fontSizes;
    },

    setFonts(fontsOptions: FontOptions) {
      this.customFonts = fontsOptions;
      const { error, data, success } = FontsSchema.safeParse(
        fontsOptions.fonts
      );
      if (!success) {
        console.error("Error loading fonts", error.issues);
        const notificationsStore = useNotificationsStore();
        notificationsStore.createNotification({
          text: "Error loading fonts",
          type: "error",
        });
        return;
      }
      if (fontsOptions.override) {
        this.fonts = data;
      } else {
        this.fonts = [...this.fonts, ...data];
      }
    },
  },
});
